
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1024","height":"1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.083 461.525C23.083 239.402 242.432 58.666 512 58.666s488.917 180.779 488.917 402.859c0 222.08-219.349 402.816-488.917 402.816a584.151 584.151 0 01-162.133-22.656L88.491 963.328a21.769 21.769 0 01-9.003 2.005 21.336 21.336 0 01-19.072-30.934l97.451-194.859C74.056 671.344 24.711 569.562 23.083 461.524zM232.917 464c0 35.347 28.653 64 64 64 35.345 0 64-28.653 64-64s-28.655-64-64-64c-35.347 0-64 28.653-64 64zM512 400c-35.347 0-64 28.653-64 64s28.653 64 64 64 64-28.653 64-64-28.653-64-64-64zm149.333 64c0 35.347 28.653 64 64 64s64-28.653 64-64-28.653-64-64-64-64 28.653-64 64z"}})])
          )
        }
      }
    